<template>
  <div class="position-relative">

    <v-overlay :value="fullLoading === false">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialog" max-width="700" persistent min-height="1000">
      <v-card style="min-height: 700px;">
        <v-card-title class="d-flex justify-space-between align-center">
          <v-row>
            <v-col cols="9" style="font-size: 18px;font-weight: bold;color: #002E5E;">
              <div v-html="lang === 'th'
                ? 'วิธีร่วมสนุก<br>“CAP ME IF YOU CAN”'
                : 'How to join<br>“CAP ME IF YOU CAN”'">
              </div>
            </v-col>
            <v-col cols="3" class="pl-0">
              <div style="text-align: end;">
                <v-chip class="mr-2" @click="toggleLang()">
                  <v-avatar left>
                    <v-img :src="lang === 'th' ? thai : eng"></v-img>
                  </v-avatar>
                    {{ lang === 'th' ? 'TH' : 'EN' }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text style="max-height: 550px; overflow-y: auto;padding: 0px 15px 15px !important;">
          <div v-if="lang === 'th'">
            <ol>
              <li>ตามหาน้องหมีที่อยู่ในงานทั้ง 7 ตัว โดย 5 ตัวจะอยู่ในส่วนจัดแสดงพิเศษ และมีน้องหมี Secret อีก 2 ตัว</li>
              <div>
                <p>จุดที่ 1: Manufacturing Expo Forum</p>
                <p>จุดที่ 2: Tools & Tooling Pavilion</p>
                <p>จุดที่ 3: SCIP: Surface & Coatings Innovation</p>
                <p>จุดที่ 4: IPC Hand Soldering</p>
                <p>จุดที่ 5: FacTech Focus</p>
                <p>จุดที่ 6 และ 7: มุมด้านในฮอลล์ 98 และฮอลล์ 104</p>
              </div>
              <li class="mb-2">สแกน QR Code บนตัวน้องหมีเพื่อสะสมแต้ม</li>
              <li class="mb-2">สแกนน้องหมีครบ 7 จุด จะได้รับข้อความยืนยัน</li>
              <li class="mb-2">โชว์ข้อความที่จุดกิจกรรมบูธ 1A37 ฮอลล์ 101</li>
              <li class="mb-2">เล่นเกมส์ลุ้นรับของที่ระลึก</li>
            </ol>
            <p class="pl-3"><strong>หมายเหตุ</strong></p>
            <ul>
              <li>เฉพาะผู้ที่ลงทะเบียนเข้าชมงาน Manufacturing Expo 2025 เท่านั้น</li>
              <li>ร่วมกิจกรรมได้เพียง 1 ครั้ง/คน</li>
              <li>ของที่ระลึกมีจำนวนจำกัด และไม่สามารถแลกเปลี่ยนเป็นเงินสด</li>
              <li>คำตัดสินของเจ้าหน้าที่ถือเป็นที่สิ้นสุด</li>
            </ul>
          </div>

          <div v-else>
            <ol>
              <li>Look for the seven bear figures at the event; five are in special zones, and two are secret bears.</li>
              <ul>
                <p>Point 1: Manufacturing Expo Forum</p>
                <p>Point 2: Tools & Tooling Pavilion</p>
                <p>Point 3: SCIP: Surface & Coatings Innovation</p>
                <p>Point 4: IPC Hand Soldering</p>
                <p>Point 5: FacTech Focus</p>
                <p>Point 6 and 7: Inner corners of Hall 98 and Hall 104</p>
              </ul>
              <li>Scan the QR code on the bears to collect points.</li>
              <li>Once all seven are scanned, you'll receive a confirmation message.</li>
              <li>Show the message at activity booth 1A37, Hall 101.</li>
              <li>Play a game and receive a souvenir!</li>
            </ol>
            <p class="pl-3"><strong>Remarks</strong></p>
            <ul>
              <li>Only registered visitors of Manufacturing Expo 2025 are eligible</li>
              <li>One participation per person only</li>
              <li>Souvenirs are limited and cannot be exchanged for cash</li>
              <li>The decision of the staff is final</li>
            </ul>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn color="#002E5E" dark block large @click="checkMemberUpdate()">
            <span v-if="lang === 'th'">
              รับทราบและยอม <br> รับเงื่อนไขในการร่วมกิจกรรม
            </span>
            <span v-else>
              Accept the terms <br>  of participation in the event
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" persistent max-width="700" min-height="1000">
      <v-card style="min-height: 500px;">
        <v-card-title class="d-flex justify-space-between align-center">
          <v-row>
            <v-col cols="12" style="font-size: 18px;font-weight: bold;color: #002E5E;">
              <div>
                <p class="mb-0" style="text-align: center;">Congratulations!</p>
                <p class="mb-0" style="text-align: center;">คุณสะสมแต้มครบแล้ว</p>
              </div>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text style="padding: 0px 15px 15px !important;font-size: 15px;">
          <div>
            <p class="mb-0" style="text-align: center;">แสดงข้อความนี้ที่บูธกิจกรรม เพื่อลุ้นรับของที่ระลึก</p>
            <p class="mb-0" style="text-align: center;">Mission complete.  Show this message at the </p>
            <p class="mb-0" style="text-align: center;">activity booth to enter a raffle to win ME</p>
            <p style="text-align: center;">souvenir</p>
          </div>
          <div>
            <v-col cols="12" style="justify-content: center; display: flex;">
              <v-img
                src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/uploadFile/ADDCOIN7810_20250608203505292187.png"
                max-width="100"
                max-height="100"
                contain
              />
            </v-col>
          </div>
          <div class="addd">
            <p class="mb-1" style="text-align: center;">"CAP ME IF YOU CAN"</p>
            <p class="mb-0" style="text-align: center;">booth 1A37, hall 101</p>
          </div>
          <!-- <div style="text-align: center;" class="mb-2">
            <a href="https://lin.ee/ip2m7or">https://lin.ee/ip2m7or</a>
          </div>
          <div>
            <p class="mb-0" style="text-align: center;">กดลิงค์นี้เมื่ออยู่ที่บูธกิจกรรมเท่านั้น</p>
            <p  style="text-align: center;">Click this link only when at the activity booth.</p>
          </div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-img
      src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/reward/REWARD132_20250605155059268500.jpg"
      class="bg-image"
    ></v-img>
    <div class="content-on-top">
      <!-- เนื้อหาด้านบน background -->
      <v-img
        src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/reward/REWARD1761_20250605155331686930.png"
        cover
      ></v-img>
      <v-divider class="my-4" style="height: 5px; background-color: white"></v-divider>
      <v-row>
        <v-col cols="6" class="pr-0">
          <v-img
            src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/reward/REWARD3025_20250605155934433622.png"
            cover
          ></v-img>
        </v-col>
        <v-col cols="6" class="pl-0">
          <v-img
            src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/reward/REWARD8265_20250605160353697265.png"
            cover
          ></v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn color="red" dark large block style="font-size: 25px;letter-spacing: 0px;font-weight: 800;" @click="openScan"><v-icon class="mr-5">mdi-scan-helper</v-icon>SCAN NOW</v-btn>
        </v-col>
      </v-row>
      <v-row style="" v-if="fullLoading === true">
          <v-col cols="12">
            <v-row>
              <v-col cols="2" class="pr-2">
                <v-card height="90" :style="'display: flex;align-items: center;justify-content: center;font-weight: bold;font-size: 25px;' + checkFont(dataStamp.boots1)">1</v-card>
              </v-col>
              <v-col cols="10" class="pl-0">
                <v-card height="90" class="pa-3" :style="'justify-content: center;display: flex;' + checkTrue(dataStamp.boots1)">
                  <v-img
                    :class="dataStamp.boots1 === 'True' ? '' : 'grayscale-img'"
                    max-height="150"
                    max-width="250"
                    contain
                    src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/reward/REWARD3398_20250605171023027248.png"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="2" class="pr-2">
                <v-card height="90" :style="'display: flex;align-items: center;justify-content: center;font-weight: bold;font-size: 25px;' + checkFont(dataStamp.boots2)">2</v-card>
              </v-col>
              <v-col cols="10" class="pl-0">
                <v-card height="90" class="pa-3" :style="'justify-content: center;display: flex;' + checkTrue(dataStamp.boots2)">
                  <v-img
                    :class="dataStamp.boots2 === 'True' ? '' : 'grayscale-img'"
                    max-height="90"
                    max-width="90"
                    src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/uploadFile/ADDCOIN6216_20250608030817787651.png"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="2" class="pr-2">
                <v-card height="90" :style="'display: flex;align-items: center;justify-content: center;font-weight: bold;font-size: 25px;' + checkFont(dataStamp.boots3)">3</v-card>
              </v-col>
              <v-col cols="10" class="pl-0">
                <v-card height="90" class="pa-3" :style="'justify-content: center;display: flex;' + checkTrue(dataStamp.boots3)">
                  <v-img
                    :class="dataStamp.boots3 === 'True' ? '' : 'grayscale-img'"
                    max-height="150"
                    max-width="250"
                    contain
                    src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/uploadFile/ADDCOIN3721_20250608031517221002.png"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="2" class="pr-2">
                <v-card height="90" :style="'display: flex;align-items: center;justify-content: center;font-weight: bold;font-size: 25px;' + checkFont(dataStamp.boots4)">4</v-card>
              </v-col>
              <v-col cols="10" class="pl-0">
                <v-card height="90" class="pa-3" :style="'justify-content: center;display: flex;' + checkTrue(dataStamp.boots4)">
                  <v-img
                    :class="dataStamp.boots4 === 'True' ? '' : 'grayscale-img'"
                    max-height="150"
                    max-width="250"
                    contain
                    src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/uploadFile/ADDCOIN7908_20250608031649271185.png"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="2" class="pr-2">
                <v-card height="90" :style="'display: flex;align-items: center;justify-content: center;font-weight: bold;font-size: 25px;' + checkFont(dataStamp.boots5)">5</v-card>
              </v-col>
              <v-col cols="10" class="pl-0">
                <v-card height="90" class="pa-3" :style="'justify-content: center;display: flex;' + checkTrue(dataStamp.boots5)">
                  <v-img
                    :class="dataStamp.boots5 === 'True' ? '' : 'grayscale-img'"
                    max-height="150"
                    max-width="250"
                    contain
                    src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/uploadFile/ADDCOIN9562_20250608031742603511.png"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="2" class="pr-2">
                <v-card height="90" :style="'display: flex;align-items: center;justify-content: center;font-weight: bold;font-size: 25px;' + checkFont(dataStamp.boots6)">6</v-card>
              </v-col>
              <v-col cols="10" class="pl-0">
                <v-card height="90" class="pa-3" :style="'justify-content: center;display: flex;' + checkTrue(dataStamp.boots6)">
                  <v-img
                    :class="dataStamp.boots6 === 'True' ? '' : 'grayscale-img'"
                    max-height="150"
                    max-width="250"
                    contain
                    src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/uploadFile/ADDCOIN6766_20250608031911835760.png"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="2" class="pr-2">
                <v-card height="90" :style="'display: flex;align-items: center;justify-content: center;font-weight: bold;font-size: 25px;' + checkFont(dataStamp.boots7)">7</v-card>
              </v-col>
              <v-col cols="10" class="pl-0">
                <v-card height="90" class="pa-3" :style="'justify-content: center;display: flex;' + checkTrue(dataStamp.boots7)">
                  <v-img
                    :class="dataStamp.boots7 === 'True' ? '' : 'grayscale-img'"
                    max-height="150"
                    max-width="250"
                    contain
                    src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/uploadFile/ADDCOIN1433_20250608031954421575.png"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex justify-center">
          <v-img
            max-width="200"
            src="https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/reward/REWARD4257_20250605161850112156.png"
            cover
          ></v-img>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'
import bgImage from '@/assets/ME 2025_BG only.jpg'

export default {
  name: 'Card',
  data () {
    return {
      dialogSuccess: false,
      thai: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e',
      eng: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b',
      dialog: false,
      lang: 'th',
      bgImage,
      anotherAnswer: ['SCG Smart Living Business', 'SCG Cement & Green Solution Business', 'SCG Distribution & Retail Business', 'SCG Decor Business'],
      dataStamp: null,
      nameSurname: null,
      major: null,
      subMajor: null,
      loading: false,
      customFeild: [],
      theme: null,
      success: false,
      screenHeight: window.innerWidth,
      stampData: null,
      overlay: false,
      Business: null,
      heightDevice: 0,
      fullLoading: false,
      choiceGender: [
        {text: 'ชาย', value: 'male'},
        {text: 'หญิง', value: 'female'},
        {text: 'lgbt', value: 'lgbt'}
      ],
      form: {
        tel: '',
        bdDate: '',
        nameCustomer: ''
      },
      profile: {
        userId: '',
        displayName: '',
        pictureUrl: '',
        statusMessage: ''
      },
      profile_dev: {
        displayName: 'Tommm',
        pictureUrl:
          'https://sprofile.line-scdn.net/0hZRsyZnrmBX1eAC76d817Ai5QBhd9cVxvc2UYSW1QWk4xORZ4d24dHmMAC0ViZRJ-czQZTz4GXEVSE3IbQFb5SVkwW0pnMkQsc29Jnw',
        statusMessage: 'บังไค (Smug)',
        userId: 'Uce4206cc8a8aecce95875fa90b88347b'
      },
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length > 11 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอก.',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = 'YEAR'))
    }
  },
  computed: {
    newData () {
      return this.GET_MEMBERINFO()
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.sorce = this.$route.query.sorce
    //   this.theme = await this.GET_THEME()
    this.heightDevice = window.screen.height + 190
    if (this.isDesktopDevice()) {
    } else {
    }
    await this.getStampData()
    if (this.dialog === false) {
      await this.checkMember()
      this.fullLoading = true
    } else {
      this.fullLoading = true
    }
    // let shopId = this.GET_SHOPID()
    // if (shopId === 'U5bad3d6f53733785f626ceaeaad539f5') {
    //   let data = {
    //     'lineUserId': this.newData.lineUserId
    //   }
    //   let result = await this.callBeTaskAPI('post', `/scg/checkCustomFeild/get`, data)
    //   if (result) {
    //     console.log('result', result)
    //     if (result[0].regisCustomFeild === null) {
    //     // alert('ddddd')
    //       this.overlay = true
    //       await this.getStampData()
    //     } else {
    //       await this.checkMember()
    //       await this.getStampData()
    //     }
    //   }
    // }
  // if (this.newData.boots1 === 'True' && this.newData.boots2 === 'True' && this.newData.boots3 === 'True' && this.newData.boots4 === 'True' && this.newData.boots5 === 'True' && this.newData.boots6 === 'True') {
  //   this.success = true
  // }
  },
  beforeDestroy () {
  // Remove the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateScreenHeight)
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapActions('lineStore', ['setProfile']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_SHOPINFO', 'GET_THEME']),

    async checkMemberUpdate () {
      this.fullLoading = false
      let form = {'rule_and_condition': 'True'}
      await this.callBeTaskAPI('post', `/rxTradex-condition/edit/${this.newData.lineUserId}`, form)
      this.dialog = false
      await this.checkMember()
      this.fullLoading = true
    },
    isDesktopDevice () {
      const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())
      const isSmallScreen = window.innerWidth <= 768
      return !(isMobile || isSmallScreen)
    },
    toggleLang () {
      this.lang = this.lang === 'th' ? 'en' : 'th'
    },
    checkFont (data) {
      if (data === 'True') {
        return 'background-color: #002E5E;color: white;'
      } else {
        return 'background-color: #d4d4d4;color: #666666;'
      }
    },
    checkTrue (data) {
      if (data === 'True') {
        return 'background: white;'
      } else {
        return 'background: #d4d4d4;'
      }
    },
    async getStampData () {
      let data = {
        'lineUserId': this.newData.lineUserId
      }
      let result = await this.callBeTaskAPI('post', `/rxTradex/line/get`, data)
      this.dataStamp = result[0]
      if (this.dataStamp.rule_and_condition === 'False') {
        this.dialog = true
      }
      if (this.dataStamp.boots1 === 'True' && this.dataStamp.boots2 === 'True' && this.dataStamp.boots3 === 'True' && this.dataStamp.boots4 === 'True' && this.dataStamp.boots5 === 'True' && this.dataStamp.boots6 === 'True' && this.dataStamp.boots7 === 'True') {
        this.dialogSuccess = true
      }
    },
    updateScreenHeight () {
      this.screenHeight = window.innerWidth
    },
    async checkMember () {
      setTimeout(() => {
      // this.showContent = true
      }, 1000)
      if (this.newData) {
      // this.checkIsMember = true
        if (this.sorce) {
          let form = {}
          form[this.sorce] = 'True'
          let res = await this.callBeTaskAPI('post', `/rxTradex/edit/${this.newData.lineUserId}`, form)
          if (res.status === true) {
            Swal.fire({
              title: `คุณได้รับแสตมป์`,
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'ตกลง'
            })
          }
          await this.getStampData()
        // await this.setProfile(this.profile)
        }
      } else {
        alert('fff123')
        this.checkIsMember = false
      }
    },
    async updateBusiness () {
      try {
        this.loading = true
        let form = [{'customFeildName': 'Business Unit', 'value': this.Business}, {'customFeildName': 'Email'}]
        let param = {regisCustomFeild: null}
        param.regisCustomFeild = JSON.stringify(form)
        await this.callBeTaskAPI('post', `/scg/editUpdateMemberCustomFeild/${this.newData.memberId}`, param)
        this.loading = true
        this.overlay = false
        await this.checkMember()
        await this.getStampData()
      } catch (error) {

      }
    // form = [{"customFeildName": Business},{"customFeildName":"Email"}]
    // let param = {regisCustomFeild: null}
    // param.regisCustomFeild = JSON.stringify(form)
    // await this.callBeTaskAPI('post', `/scg/edit/up${this.newData.memberId}`, form)
    // this.overlay =
    },
    async openScan () {
      const result = await axios.get(this.DNS_Link + `/lineconfig/get?shopId=SD_1749094171700`)
      if (Array.isArray(result.data)) {
        if (result.data[0].liffMainIDLoyalty !== null) {
          this.$liffId = result.data[0].liffMainIDLoyalty
        } else {
          this.$liffId = '1656906322-JN5MM8Ep'
        }
      }
      await this.$liff.init({
        liffId: this.$liffId
      }).then(async () => {
        await this.$liff.ready.then(async () => {
          if (process.env.NODE_ENV !== 'development') {
            if (!this.$liff.isLoggedIn()) {
              await this.$liff.login({ redirectUri: window.location.href })
            } else {
              try {
                const result = await this.$liff.scanCodeV2()

                if (result.value && result.value !== 'null') {
                  window.location.href = result.value
                } else {
                }
              } catch (error) {
                console.error('scanCodeV2 error:', error)
              }
            }
          }
        })
      }).catch((err) => {
        alert('เกิดข้อผิดพลาดในการโหลด LIFF')
        console.error(err.code, err.message)
      })
    }
  }
// async mounted() {
//     this.sorce = this.$route.query.sorce
//     this.profile = this.getLiffProfile()
//     this.checkMember()
//     console.log('a', this.sorce)
//   },
//   methods: {
//     ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
//     ...mapGetters('memberStore', ['GET_MEMBERINFO']),
//     ...mapActions('lineStore', ['setProfile']),

//     async checkMember () {
//       console.log('ddcheckMemberddd')
//       setTimeout(() => {
//         this.showContent = true
//       }, 1000)
//       console.log('this.newData', this.newData)
//       if (this.newData) {
//         this.checkIsMember = true
//         if (this.sorce) {
//           let form = {}
//           form[this.sorce] = 'True'
//           console.log('form', typeof this.profile.userId)
//           await this.callBeTaskAPI('post', `/memberSWU/edit/${this.profile.userId}`, form)
//           await this.setProfile(this.profile)
//         }
//       } else {
//         this.checkIsMember = false
//       }
//       console.log('ddcheckMemberddd')
//     },
//   }
}
</script>
<style scoped>
label {
  display: inline-block;
  margin: 10px;
}
.btnJa {
    background-color:white;
    padding: 3px 15px 3px 15px;border-radius: 10px;
    border: 2px solid #A5BECC;
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.3);
    transition: all ease 0.3s;
}
.activeGender {
  background-color:#14C38E;
  padding: 3px 20px 3px 20px;border-radius: 10px;
  color: white;
  border: 2px solid #A5BECC;
  transform: translateY(-5px);
  box-shadow: 0px 10px 20px 2px rgba(0, 0, 0, 0.25);
  transition: all ease 0.3s;
}
.v-input__slot {
  top: -16px;
}
.cardRegis {
    line-height: 35px;
    border-radius: 10px;
    box-shadow: 10px 10px 20px #e6e6e6;
  }
.justify {
  justify-content: center;
  display: flex;
}
.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.content-on-top {
  position: relative;
  z-index: 1;
  padding: 20px;
  color: white;
}
.content-on-top {
  position: relative;
  min-height: 120vh; /* หรือกำหนดความสูงเช่น 400px */
}
.sticky-bottom-bar {
  bottom: 0;
  width: 50%;
  height: 3px;
  align-items: flex-end;
  display: flex;
  padding-bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.grayscale-img {
  filter: grayscale(100%);
}
.addd{
  font-size: 20px;
  margin-bottom: 10px;
  margin-top: 10px;
  color: #2E263D;
  font-weight: 800;
  letter-spacing: 1px;
}
.bottom-bar {
  margin-top: auto;
  width: 50%;
  height: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Card/StampRXTradex.vue